<template>
  <span
    :class="{ 'sb-pagination__placeholder': isPlaceholder }"
    data-testid="pagination-pages-information"
  >
    {{ text }}
  </span>
</template>

<script lang="ts" setup>
import { computed } from 'vue'
import i18n, { type Locale } from '../../../i18n'

export type paginationPagesTextProps = {
  currentPage?: number
  isPlaceholder?: boolean
  pages?: number
  showCurrentPage?: boolean
  locale?: Locale
}

const props = withDefaults(defineProps<paginationPagesTextProps>(), {
  currentPage: 1,
  isPlaceholder: false,
  pages: 1,
  showCurrentPage: false,
  locale: 'en',
})

const text = computed(() => {
  const ofTranslated = i18n(props.locale, 'of')

  return props.showCurrentPage
    ? `${props.currentPage}/${props.pages}`
    : `${ofTranslated} ${props.pages}`
})
</script>
